import API from '.';

export default class ITSiteCode {
  /**
   * The itSiteCode dimension table for UDM
   * @param {number} itSiteCodeId Id of the itSiteCode.
   * @param {string} itSiteCode Name of the itSiteCode.
   * @param {string} itSiteCodeDesc Description of the itSiteCode.
   */
  constructor({ itSiteCodeId, itSiteCode, itSiteCodeDesc }) {
    this.itSiteCodeId = itSiteCodeId;
    this.itSiteCode = itSiteCode;
    this.itSiteCodeDesc = itSiteCodeDesc;
  }

  static async getAll() {
    const api = await API();
    const { data } = await api.get('/ITSiteCode');
    return data.map((d) => new ITSiteCode(d));
  }

  static async get(id) {
    const api = await API();
    const { data } = await api.get(`ITSiteCode/${id}`);
    return new ITSiteCode(data);
  }

  // static async create(data) {
  //   const api = await API();
  //   console.log(data);
  //   const { res } = await api.post('itSiteCode', data);
  //   return res;
  // }

  // static async update (id, data) {
  //   const api = await API();
  //   const { res } = await api.put(`/itSiteCode`, data);
  //   return res;
  // }
}
